import { apiGet, apiPair, apiPatch, apiGetAllPaginatedCollections } from '../js/api';
import type { CustomRequestOptions } from '../js/api';

import Server from '../js/config/_server';
import type { CollectionResponse, ResourceResponse } from './types/response';
import type { Device, Playlist } from './types/index';
import { playlistsMock } from './playlistMock';
import type { SearchParams } from './search';

/**
 *
 * @param {Object} args
 * @param {string} args.dealerNumber
 * @param {string} args.pin
 */
export const pairDevice = args => {
    const url = Server.baseUrl + Server.services.devices.pair;
    const options = {
        body: {
            pin: args.pin,
            dealership: args.dealerIri
        }
    };
    return apiPair(url, options);
};

type Options = CustomRequestOptions & {
    params: {
        dealershipId?: string | string[];
        deviceNumber?: string | string[];
    } & Pick<SearchParams, 'page'>;
};

export interface TypeDealership {
  title: string;
  country: string;
}

export const getAllUserDevices = options => {
    const url = Server.baseUrl + Server.services.devices.userDevices;
    return apiGetAllPaginatedCollections(url, options);
};

export const getDevices = (options?: Options) => {
    const url = Server.baseUrl + Server.services.devices.userDevices;
    return apiGet<CollectionResponse<Device>>(url, options);
};

export const getDevice = (id: string, brand: string) => {
    const url = `${Server.baseUrl}/brands/${brand}/devices/${id}`;
    return apiGet<ResourceResponse<Device>>(url);
};

export const getDeviceRecentPlaylists = (id: string) => {
    const url = `${Server.baseUrl}${Server.services.devices.getAll}/${id}/recent-playlists`;
    return apiGet<ResourceResponse<Playlist[]>>(url);
};

const mockFetch = () =>
    new Promise<typeof playlistsMock>(resolve => {
        setTimeout(() => {
            resolve(playlistsMock);
        }, 500);
    });
export const getRecentPlaylists = () => {
    return mockFetch();
};

export const updateDevice = (deviceId, body) => {
    const url = `${Server.baseUrl}${deviceId}`;
    const options = {
        body
    };
    return apiPatch(url, options);
};

export const getDealer = kvps => {
    const url = Server.baseUrl + Server.services.dealerships.getOne + '/' + kvps;
    return apiGet<TypeDealership>(url);
};

export const devices = {
    pairDevice,
    getDevices,
    getAllUserDevices,
    getRecentPlaylists,
    updateDevice,
    getDealer
};
